<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="flex flex-wrap items-end">
                <div class="flex-grow">
                    <vs-button
                        v-if="isPermissionAdd()"
                        @click="addCamera"
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-plus">
                        {{this.$t('news.addNews')}}
                    </vs-button>
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="listNews"
                         :localeText="{noRowsToShow: this.$t('menuCamera.noRowsToShow')} "
                         :animateRows="true"
                         :paginationPageSize="pageSize"
                         :pagination="true"
                         @pagination-changed="onPaginationChanged"
                         @grid-ready="onGridReady"
                         :autoSizeStrategy="autoSizeStrategy">
            </ag-grid-vue>

            <vs-pagination
                :total="totalPages"
                v-model="currentPage"
                @input="loadPage"/>
        </div>
    </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Pagination from "../../ui-elements/Pagination.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import CellRendererContent from "./cell-renderer/CellRendererContent";
import { isAPI, isRouter } from "../../../store/permission";
import { constAPI, constRouter } from "../../../store/constant";

export default {
    components: {
        AgGridVue,

        // Cell Renderer
        Pagination,
        CellRendererActions,
        CellRendererContent,
    },
    data() {
        return {
            searchQuery: "",
            // AgGrid
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('news.humanCreate'),
                    field: 'employeeDetailResponseDTO.fullName',
                    width: 120
                },
                {
                    headerName: this.$t('news.department'),
                    field: 'departmentResponseDTO.departmentName',
                    width: 170
                },
                {
                    headerName: this.$t('news.title'),
                    field: 'title',
                    width: 120
                },
                {
                    headerName: this.$t('news.content'),
                    field: 'content',
                    cellRenderer: 'CellRendererContent',
                    width: 250,
                },
                {
                    headerName: this.$t('news.actions'),
                    field: 'actions',
                    width: 100,
                    cellRenderer: 'CellRendererActions',
                },
            ],
            listNews: [],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
            pageSize: 50,
        }
    },
    created() {
        this.initScreen();
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteNews'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('DELETE_NEWS', false);
            }
        },
    },
    methods: {
        isPermissionAdd() {
            return isRouter(this, constRouter.news_add)
        },
        updateSearchQuery(val) {
            this.gridApi.setGridOption('quickFilterText', val);
        },
        addCamera() {
            this.$router.push('/user/add-news').catch(() => {
            })
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },

        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },

        initScreen() {
            this.$vs.loading();
            this.$crm.get('/posts/find-all').then((response) => {
                this.listNews = response.data.map(item => {
                    if (item.employeeDetailResponseDTO == null) {
                        item.employeeDetailResponseDTO = {fullName: 'Quản trị viên'};
                    }
                    return item
                });
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    },
    mounted() {
        setTimeout(() => {
            if (this.listNews.length < 1) {
                document.getElementsByClassName("ag-overlay-no-rows-center")[0].innerText = "Chưa có bài viết.";
            }
        }, 200);
    }
}
</script>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
